import { gql } from "graphql-request";

export const projectInvitations = {
  getProjectInvitations: gql`
    query ProjectInvitations($projectId: String!) {
      summary {
        project(projectId: $projectId) {
          metadata
        }
      }
    }
  `,
};
